import { defineMessages } from 'react-intl';

export const i18n: {
	space: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	drive: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	drivePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	site: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sitePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterSpacePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	space: {
		id: 'search-page.filters.names.space',
		defaultMessage: 'Space',
		description: 'Label for filtering by space',
	},
	drive: {
		id: 'search-page.filters.names.drive',
		defaultMessage: 'Drive',
		description: 'Label for filtering by drive in Google Drive',
	},
	drivePlaceholder: {
		id: 'search-page.google-drive.filter.drive.placeholder',
		defaultMessage: 'Find drives',
		description: 'Placeholder for drive filter search input',
	},
	site: {
		id: 'search-page.filters.names.site',
		defaultMessage: 'Site',
		description: 'Label for filtering by site in SharePoint',
	},
	sitePlaceholder: {
		id: 'search-page.sharepoint.filter.site.placeholder',
		defaultMessage: 'Find sites',
		description: 'Placeholder for site filter search input',
	},
	confluenceFilterSpacePlaceholder: {
		id: 'search-page.confluence.filter.space.placeholder',
		defaultMessage: 'Find spaces',
		description: 'Placeholder for space filter search input',
	},
	confluenceFilterLabelSelected: {
		id: 'search-page.confluence.filter.label.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter label selected',
	},
	confluenceFilterLabelUnselected: {
		id: 'search-page.confluence.filter.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Confluence filter label unselected',
	},
	confluenceIconLabel: {
		id: 'search-page.confluence.filter.icon.label',
		defaultMessage: 'Confluence filter',
		description:
			'An icon that is displayed when there are no products selected to signify that the filter is associated with Confluence',
	},
});
